import React from "react";
import API_BASE_URL from "../config/apiConfig";
import { useAuth } from "../context/AuthProvider";

type Props = {
  start_time: string; // ISO: 2026-02-03T00:00:00
  end_time: string;   // ISO: 2026-02-03T23:59:59.999
};

const ExportScores: React.FC<Props> = ({ start_time, end_time }) => {
  const { token } = useAuth();

  const isoToDate = (iso: string) => {
    // "2026-02-03T00:00:00" -> "2026-02-03"
    return (iso || "").split("T")[0];
  };

  const download = async () => {
    const url =
      `${API_BASE_URL}/score-config/export-table` +
      `?start_time=${encodeURIComponent(start_time)}` +
      `&end_time=${encodeURIComponent(end_time)}` +
      `&include_counts=true`;

    const r = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!r.ok) {
      const data = await r.json().catch(() => ({}));
      alert(data?.detail || "Nu s-a putut genera exportul.");
      return;
    }

    const blob = await r.blob();
    const a = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    a.href = href;

    const sd = isoToDate(start_time);
    const ed = isoToDate(end_time);
    a.download = `punctaje_${sd}_${ed}.xlsx`; // ✅ interval în nume

    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(href);
  };

  return (
    <div style={{ display: "flex", gap: 8 }}>
      <button className="primary-btn" onClick={download}>
        Export Excel
      </button>
    </div>
  );
};

export default ExportScores;